export default "__VITE_ASSET__D52xmh$7__"